import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  getImages: {
    method: 'GET',
    url: `${configs.baseUrl}/api/uploaded/images`,
  },
  deleteImage: {
    method: 'DELETE',
    url: `${configs.baseUrl}/api/uploaded/images/v2`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const getImages = async (params) => {
  return resource.getImages(params)
}

const deleteImage = async (params) => {
  return resource.deleteImage(params)
}

export default {
  initResource,
  getImages,
  deleteImage,
}
